import {Colors} from "../../colors";
import {PermanentMenuHeaderProps} from "./types";

export const getPermanentMenuHeaderStyleByType = (variant: PermanentMenuHeaderProps["type"]) => {
  switch (variant) {
    case "spring":
      return {
        border: Colors.primary._800,
        nameText: Colors.primary._200,
        emailText: Colors.primary._600,
        icon: Colors.primary._600,
      };
    case "partner":
    default:
      return {
        border: Colors.secondary._800,
        nameText: Colors.secondary._200,
        emailText: Colors.secondary._600,
        icon: Colors.secondary._600,
      };
  }
};
